module.exports = __webpack_public_path__ + "fb-tutorial-1-pl.png?a3719701cc850d4de1982f2593d3e544";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-1-pl.png
// module id = Nzyz
// module chunks = 46